export const ACTIONS = {
  FETCH_NOTES: "FETCH_NOTES",
  FETCHED_NOTES: "FETCHED_NOTES",
  ERROR_OCCURRED: "ERROR_OCCURRED",
  CREATE_NEW_NOTE: "CREATE_NEW_NOTE",
  DELETE_NOTE: "DELETE_NOTE",
  UPDATE_NOTE: "UPDATE_NOTE",
};
